import React, {useEffect, useState} from "react";
import {Button, Row, Col, Modal, Radio, notification, Table, TimePicker, Icon, Popconfirm, DatePicker} from "antd";
import '../modals.css';
import {distributionCenterService, consignorService} from "../../../services";
import Spinner from "../../spinner";
import moment from "moment/moment";
import ModalCreateGateForDistributionCenter from "../create-gate";
import SelectField from "../../select-field";
import FieldBlock from "../../field-block";
import localeDatePicker from "antd/lib/date-picker/locale/ru_RU";
import InputField from "../../input-field";
import i18n from '../../../i18n';
import { phoneHelper } from "../../../helpers/phone.helper";

export default function ModalListLoadingSchedule({
                                                   isShow, distCenterId = null,
                                                   onCloseModal,
                                                   name = ""
                                                 }) {

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [distCenters, setDistCenters] = useState([]);
  const [distCenter, setDistCenter] = useState(distCenterId);
  const [distCenterName, setDistCenterName] = useState(name)
  const [date, setDate] = useState(null);
  const [gateType, setGateType] = useState(undefined);
  const [search, setSearch] = useState('');
  const [consignors, setConsignors] = useState([]);
  const [selectedConsignor, setSelectedConsignor] = useState(undefined);
  const [isOwnerUser, setIsOwnerUser] = useState(false);

  const gateTypes = [
    {Id:'loading', Name: i18n.t('modals.modalCreateGateForDistributionCenter.fields.gateType.values.loading')},
    {Id:'unloading', Name: i18n.t('modals.modalCreateGateForDistributionCenter.fields.gateType.values.unloading')}
  ]

  useEffect(() => {
    if (date === null) {
      setDate(moment());
    }

    if (!isShow) return;

    consignorService.getInfo()
      .then((info) => {
        setIsOwnerUser(info.isOwner);

        if (info.isOwner) {
          return consignorService.getConsignorsList()
            .then((list) => {
              const consignorsData = list.map((item) => ({
                id: item.Id || item.id,
                name: item.Name || item.name,
              }));
              setConsignors(consignorsData);
              if (consignorsData.length > 0) {
                setSelectedConsignor(consignorsData[0].id);
              }
            });
        }
      })
      .catch(() => {});

  }, [isShow])

  useEffect(() => {
    if (!isShow || distCenterId !== null) return;

    const consignorId = isOwnerUser ? selectedConsignor : null;

    distributionCenterService.getCompanies(false, false, consignorId)
      .then((response) => {

        const distributionsCentersData = response.map((item) => {
          return {
            id: item.Id,
            name: item.Name,
          };
        });

        if (distributionsCentersData.length > 0) {
          setDistCenters(distributionsCentersData);
          setDistCenter(distributionsCentersData[0].id)
          setDistCenterName(distributionsCentersData[0].name)
        }

      }).catch((errMsg) => notification.error(
      {
        message: i18n.t('components.notification.titles.getDistributionCentersList'),
        description: errMsg
      }));
  }, [isShow, isOwnerUser, selectedConsignor])

  useEffect(() => {
    if (isShow && loading && distCenter !== null) {
      let formattedDate = null;
      if (date != null) {
        formattedDate = moment(date).format('YYYY-MM-DD');
      }
      distributionCenterService.getLoadingSchedule(distCenter, formattedDate, search, gateType)
        .then((response) => {
          setData(response);
          setLoading(false);
        })
        .catch((error) => {
          notification.error({
            message: i18n.t('components.notification.titles.getLoadingSchedule'),
            description: error,
          });
          setLoading(false);
        });
    }
  }, [distCenter, loading, isShow, date, search, gateType]);

  const columns = [
    {
      title: i18n.t('modals.modalListLoadingSchedule.table.gate.title'),
      key: 'gate',
      width: '7%',
      onCell: () => ({ style: { whiteSpace: 'normal', wordBreak: 'break-word' } }),
      render: (record) => {
        if (record.gate.realGateName != null) {
          return <span>{record.gate.realGateName}</span>
        }
        return <span>{record.gate.name}</span>
      }
    },
    {
      title: i18n.t('modals.modalListLoadingSchedule.table.dataTime.title'),
      key: 'dataTime',
      width: '7%',
      onCell: () => ({ style: { whiteSpace: 'normal', wordBreak: 'break-word' } }),
      render: (record) => {
        if(date) {
          return moment(record.dataTime, "DD.MM.YYYY HH:mm").format("HH:mm");
        } else {
          return record.dataTime;
        }
      }
    },
    {
      title: i18n.t('modals.modalListLoadingSchedule.table.operationType.title'),
      key: 'operationType',
      width: '7%',
      render: (record) => {
        if (record.type === 'loading') {
          return (
            <>
            <span>{i18n.t('modals.modalListLoadingSchedule.table.operationType.values.loading')}</span>
            </>
          )
        } else if (record.type === 'unloading') {
          return (
            <>
            <span>{i18n.t('modals.modalListLoadingSchedule.table.operationType.values.unloading')}</span>
            </>
          )
        }
      }
    },
    {
      title: i18n.t('modals.modalListLoadingSchedule.table.driver.title'),
      key: 'driver',
      width: '10%',
      render: (record) => {
        return <>
          <div>{record.driver.fio}</div>
          {phoneHelper.phoneLink(record.driver.phone)}
        </>
      }
    },
    {
      title: i18n.t('modals.modalListLoadingSchedule.table.carcassType.title'),
      key: 'carcass',
      width: '5%',
      render: (record) => {
        return <>
          {record.carcass}
        </>
      }
    },
    {
      title: i18n.t('modals.modalListLoadingSchedule.table.legalEntity.title'),
      key: 'legalEntity',
      width: '10%',
      render: (record) => {
        if (record.delivery != null) {
          return (<>
            <div>
              {record.carrierLegalTitle}
            </div>
            <div>
              {phoneHelper.phoneLink(record.carrierPhone)}
            </div>
            </>
          )
        } else {
          return (
            <>
            <div>
              {record.suplier.name}
            </div>
            </>
          )
        }
      }
    },
    {
      title: i18n.t('modals.modalListLoadingSchedule.table.delivery.title'),
      key: 'delivery',
      width: '7%',
      render: (record) => {
        if (record.delivery != null) {
          return (<>
            <span>№ {record.delivery.number}</span>
            </>
          )
        } else {
          return (
            <>
              <span>-</span>
            </>
          )
        }
      }
    },
    {
      title: i18n.t('modals.modalListLoadingSchedule.table.actualTime.title'),
      width: '7%',
      render: (record) => {
        if (record.actualTime) {
          return record.actualTime;
        }
        return null;
      }
    },
  ];


  return (
    <Modal
      title={<span dangerouslySetInnerHTML={{__html: i18n.t('modals.modalListLoadingSchedule.title', {distCenterName: distCenterName })}}/>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setData([])
        onCloseModal();
      }}
      forceRender={true}
      footer={<div></div>}
    >
      <Spinner loading={loading}>
        <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
          <Col lg={4} md={24} sm={24} xs={24}>
            <FieldBlock getErrors={()=>{}} 
              //title={'Дата'}
            >
            <DatePicker

              disabledDate={(current) => current && current < moment().startOf('day')}
              allowClear={true}
              style={{width: "100%"}}
              defaultValue={date}
              format="DD.MM.YYYY"
              size="large"
              name="date"
              locale={localeDatePicker}
              onChange={(val) => {
                setLoading(true);
                setDate(val);
              }}
              value={date}

            />
            </FieldBlock>
          </Col>
            {isOwnerUser && !distCenterId &&
            <Col lg={10} md={24} sm={24} xs={24}>
              <SelectField
                name="consignors"
                placeholder={i18n.t('modals.modalListLoadingSchedule.fields.consignors.placeholder')}
                getErrors={() => {}}
                onChange={(value) => {
                  setSelectedConsignor(value);
                  setDistCenters([]);
                  setDistCenter(null);
                  setDistCenterName('');
                  setData([]);
                  setLoading(true);
                }}
                style={{width: "100%"}}
                selectedValue={selectedConsignor}
                values={consignors}/>
            </Col>}
            {!distCenterId &&
            <Col lg={isOwnerUser ? 10 : 8} md={24} sm={24} xs={24}>
              <SelectField name="distCenters" 
                //title={i18n.t('modals.modalListLoadingSchedule.fields.distCenters.title')}
                placeholder={i18n.t('modals.modalListLoadingSchedule.fields.distCenters.placeholder')}
                getErrors={() => {
                }}
                onChange={(value) => {
                  const newName = distCenters.find((item) => item.id === value).name;
                  setDistCenterName(newName);
                  setDistCenter(value);
                  setLoading(true);
                }}
                style={{width: "100%"}}
                selectedValue={distCenter}
                values={distCenters}/>
            </Col>}
            <Col xs={24} sm={24} md={24} lg={8}>
              <InputField
                name="search"
                //label={i18n.t('modals.modalListLoadingSchedule.fields.search.title')}
                placeholder={i18n.t('modals.modalListLoadingSchedule.fields.search.placeholder')}
                value={search}
                setValue={(value) => {
                  setSearch(value);
                }}
                onBlur={(e) => {
                  e.stopPropagation();
                  setSearch(e.target.value);
                  setLoading(true);
                }}
                getFieldErrors={() => {
                }}
              />
            </Col>
            <Col lg={4} md={24} sm={24} xs={24}>
              <SelectField
                name="gateType" 
                //title={i18n.t('modals.modalCreateGateForDistributionCenter.fields.gateType.title')}
                placeholder={i18n.t('modals.modalListLoadingSchedule.fields.gateType.placeholder')}
                getErrors={() => {
                }}
                onChange={(value) => {
                  setGateType(value);
                  setLoading(true);
                }}
                allowClear={true}
                style={{width: "100%"}}
                selectedValue={gateType}
                values={gateTypes}/>
            </Col>
        </Row>
        <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
          <Col span={24}>
            <Table
              style={{minWidth: '100%', maxWidth: '100%'}}
              columns={columns}
              dataSource={data}
              locale={{emptyText: i18n.t('main.empty')}}
              rowKey="id"
              size="small"
            />
          </Col>
        </Row>
      </Spinner>
    </Modal>
  );
}
